export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-export-f3bea8dbefa594835d870a0cd3996365.svg";